// extracted by mini-css-extract-plugin
export var bannerContainer = "_1-0";
export var bannerImage = "_1-2";
export var bannerLoading = "_1-3";
export var bannerWrapper = "_1-1";
export var shimmer = "_1-4";